import React from 'react'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import {
  Button,
  EditableDescription,
  EditableTitle,
  ScrollRef,
  WContainer,
} from '@components/atoms'
import styles from './GenericSection.module.sass'

interface Props {
  refId?: string
  item?: MenuItemType
  theme?: GenericSectionThemeType
  children?: React.ReactNode
  editMode?: boolean
  className?: string
}

const GenericSection = (props: Props) => {
  const {
    refId = undefined,
    item = undefined,
    theme = 'white',
    children = undefined,
    editMode = false,
    className = '',
  } = props

  return (
    <div
      className={`${styles.root} 
      ${editMode ? styles['root--editMode'] : ''}
      ${item?.spaceTop ? styles[`root--st-${item.spaceTop}`] : ''} 
      ${item?.spaceBottom ? styles[`root--sb-${item.spaceBottom}`] : ''}  
      ${styles[`root--${theme}`]} ${
        item?.ctaLabel && item?.url ? styles['root--cta'] : ''
      } ${className}`}
    >
      {!!refId && <ScrollRef offset={false} id={refId} className={styles.ref} />}
      <WContainer>
        <div className={`${styles.outerLayout}`}>
          <div className={`${styles.layout}`}>
            {(editMode ||
              !!item?.name ||
              !!item?.description ||
              (!!item?.ctaLabel && !!item?.url)) && (
              <div className={styles.main}>
                <div className={styles.content}>
                  <EditableTitle title={item.name} editMode={editMode} className={styles.title} />
                  <EditableDescription
                    className={styles.description}
                    description={item.description}
                  />
                </div>
                {!!item.ctaLabel && !!item.url && (
                  <Button
                    label={item.ctaLabel}
                    size="lg"
                    variant="ghost"
                    href={item.url}
                    className={styles.cta}
                  />
                )}
              </div>
            )}
            {children}
          </div>
          {!!item?.ctaLabel && !!item?.url && (
            <Button
              label={item.ctaLabel}
              size="lg"
              variant="ghost"
              className={styles.ctaMobile}
              href={item.url}
            />
          )}
        </div>
      </WContainer>
    </div>
  )
}

export default GenericSection
